const PASSWORD_RULES = [
  {
    id: 5,
    rule: /.{8,}/,
    label: "A senha deve conter ao menos oito caracteres",
  },
  {
    id: 3,
    rule: /\d/,
    label: "A senha deve conter ao menos um número",
  },
  {
    id: 1,
    rule: /[A-Z]/,
    label: "A senha deve conter ao menos uma letra maiúscula",
  },
  {
    id: 2,
    rule: /[a-z]/,
    label: "A senha deve conter ao menos uma letra minúscula",
  },
  {
    id: 4,
    rule: /[^A-Za-z0-9]/,
    label: "A senha deve conter ao menos um caractere especial",
  },
];

const PASSWORD_LEVELS = [
  { label: "Fraca", color: "var(--mantine-color-V500-0)" },
  { label: "Média", color: "var(--mantine-color-A500-0)" },
  { label: "Forte", color: "#5BBD00" },
] as const;

export { PASSWORD_RULES, PASSWORD_LEVELS };
